module.exports = __webpack_public_path__ + "img/charging-hub-in-progress-semipublic.6384d078.png";